const checkSpecialOffersValid = ({specialOffers, setSpecialOfferEnabled}) => {
  
  // Check array of offers to see if any offers are enabled
  specialOffers.map(offer => {
    return Object.entries(offer).forEach(([key, value]) => {
      if(key === 'enabled') {
        if(value === true) {
          // Check if current date falls within offer start / end dates
          const todayDate = new Date()
          const startDate = new Date(offer.startDate)
          const endDate = new Date(offer.endDate)
          
          if((todayDate > startDate && todayDate < endDate) === true) {
            setSpecialOfferEnabled(true)
          }
        }
      }
    })
  })
}

export default checkSpecialOffersValid